import React from "react";

export type Platform = 'all' | 'amazon' | 'google';

interface PlatformSelectorProps {
    platform: Platform;
    onPlatformChange: (platform: Platform) => void;
}

const platforms: { value: Platform; label: string }[] = [
    { value: 'all', label: 'General SSML' },
    { value: 'amazon', label: 'Amazon Alexa' },
    { value: 'google', label: 'Google Assistant' },
];

const PlatformSelector = ({ platform, onPlatformChange }: PlatformSelectorProps) => {
    return (
        <div className="inline-flex bg-gray-100 rounded-lg p-1 gap-1">
            {platforms.map((p) => (
                <button
                    key={p.value}
                    onClick={() => onPlatformChange(p.value)}
                    className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all ${
                        platform === p.value
                            ? 'bg-white text-gray-900 shadow-soft'
                            : 'text-muted hover:text-gray-700'
                    }`}
                >
                    {p.label}
                </button>
            ))}
        </div>
    );
};

export default PlatformSelector;
